import(/* webpackMode: "eager" */ "/workspace/src/app/roletadepremios/page.tsx");
